var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticStyle: { float: "left", width: "260px" } },
          [
            _c(
              "el-form",
              { attrs: { size: "small" } },
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.queryForm.orderType,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "orderType", $$v)
                          },
                          expression: "queryForm.orderType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("collectionCenter.lanshouOrderNum"),
                            value: 0,
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("collectionCenter.Barcode"),
                            value: 1,
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("collectionCenter.parcelNum"),
                            value: 2,
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("collectionCenter.BagNumber"),
                            value: 3,
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.licensePlateNumber"
                            ),
                            value: 4,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t("collectionCenter.BatchQuery"),
                        type: "textarea",
                        rows: 20,
                      },
                      model: {
                        value: _vm.queryForm.orderNum,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "orderNum", $$v)
                        },
                        expression: "queryForm.orderNum",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value:
                              "btn:collection-center:order:track-query:find",
                            expression:
                              "'btn:collection-center:order:track-query:find'",
                            arg: "remove",
                          },
                        ],
                        attrs: {
                          type: "primary",
                          icon: "el-icon-search",
                          size: "small",
                          disabled: _vm.isNoSubmit,
                        },
                        on: { click: _vm.defaultClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", icon: "el-icon-refresh-right" },
                        on: { click: _vm.resetClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { float: "left", width: "calc(100% - 260px)" } },
          [
            _c(
              "div",
              { staticClass: "track-container" },
              [
                _c(
                  "el-tabs",
                  {
                    attrs: {
                      scrollable: { arrowVisible: true, minItemWidth: "80px" },
                    },
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "全部", name: "1" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#000000",
                              },
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticStyle: {
                                    "margin-right": "5px",
                                    float: "left",
                                  },
                                },
                                [_vm._v("all")]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("collectionCenter.tudo")) +
                                  "（" +
                                  _vm._s(_vm.dataList.all.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "1"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: { "track-data": _vm.dataList.all.list },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "揽收", name: "2" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#00A551",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-saoma",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("collectionCenter.lanshou")) +
                                  "（" +
                                  _vm._s(_vm.dataList.collection.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "2"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: {
                                "track-data": _vm.dataList.collection.list,
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "问题件", name: "3" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#F56C6C",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-yichangtishi",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("collectionCenter.ProblemPiece")
                                  ) +
                                  "（" +
                                  _vm._s(_vm.dataList.problematic.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "3"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: {
                                "track-data": _vm.dataList.problematic.list,
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "封袋", name: "4" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#f5bc17",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-fangkuangweixuan",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("collectionCenter.SealingBags")
                                  ) +
                                  "（" +
                                  _vm._s(_vm.dataList.sealedBag.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "4"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: {
                                "track-data": _vm.dataList.sealedBag.list,
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "装车", name: "5" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#20a8b0",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-a-391347311",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("collectionCenter.status6")) +
                                  "（" +
                                  _vm._s(_vm.dataList.loaded.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "5"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: { "track-data": _vm.dataList.loaded.list },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "卸车", name: "6" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#b00e85",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-a-391347312",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("collectionCenter.status7")) +
                                  "（" +
                                  _vm._s(_vm.dataList.unloaded.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "6"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: {
                                "track-data": _vm.dataList.unloaded.list,
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "签收", name: "7" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#67C23A",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-qianshou",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("collectionCenter.signFor")) +
                                  "（" +
                                  _vm._s(_vm.dataList.signFor.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "7"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: {
                                "track-data": _vm.dataList.signFor.list,
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "已闭环", name: "8" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#c72121",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-quanbuxunhuan",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("collectionCenter.closedLoop")
                                  ) +
                                  "（" +
                                  _vm._s(_vm.dataList.closedLoop.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "8"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: {
                                "track-data": _vm.dataList.closedLoop.list,
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "其他", name: "9" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                color: "#909399",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-shalou",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("collectionCenter.other")) +
                                  "（" +
                                  _vm._s(_vm.dataList.other.num) +
                                  "） "
                              ),
                            ]
                          ),
                        ]),
                        _vm.activeName === "9"
                          ? _c("track-detail", {
                              key: _vm.activeName,
                              attrs: { "track-data": _vm.dataList.other.list },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }